import { FormGroup, Input, Label, Tooltip } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkInput } from "../../Utils/otherFunctions";
import { forwardRef, useState } from "react";
import { Info, Download } from "react-feather";

const FileInputField = forwardRef(function FileInputField(props, ref) {
  const { 
    label, 
    className, 
    fieldState, 
    placeholder,
    templateUrl,
    templateHandler,
    downloadTemplateText = "Download Template" // Nilai default
  } = props;
  
  const { themeContext } = useThemeContext();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <FormGroup className={className}>
      <div className="d-flex align-items-center gap-2">
        {label && (
          <Label className="bg-transparent">
            {label}{" "}
            {props.isRequired && (
              <font className="ml-1" color="red">
                *
              </font>
            )}
            {props.tooltip && <Info id={`tooltip-${props.name}`} size={10} />}
          </Label>
        )}
        {(templateUrl || templateHandler) && (
          <a
            href={templateUrl}
            onClick={templateHandler}
            className="text-primary d-flex align-items-center gap-1 text-decoration-none"
            style={{ fontSize: '0.8rem', cursor: 'pointer' }}
          >
            <Download size={14} /> {downloadTemplateText}
          </a>
        )}
      </div>

      <Input
        className={`${getDarkInput(themeContext)} ${className || ''}`}
        invalid={fieldState?.error}
        type="file"
        placeholder={placeholder}
        ref={ref}
        isRequired={props.isRequired}
        name={props.name}
        accept={props.accept}
        onChange={(e) => props.onChange(e.target.files[0])}
        style={{ border: '1px solid black' }}
      />

      {fieldState?.error && (
        <Label className="label-text text-danger">
          {fieldState.error.message}
        </Label>
      )}

      {props.tooltip && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={`tooltip-${props.name}`}
          toggle={toggle}
        >
          {props.tooltip}
        </Tooltip>
      )}
    </FormGroup>
  );
});

export default FileInputField;